import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getCalculationStatusTypes } from 'modules/_common/api';
import { getOccupancyPartners } from 'modules/accommodations/features/occupancies/api';

export const useQueryReservationFilterMobile = (enabledOccupancyPartners?: boolean) => {
  const {
    data: source,
    isLoading,
    isError,
  } = useQuery(QUERY_KEYS.UNITS_OCCUPANCY_PARTNERS, () => getOccupancyPartners(), {
    enabled: enabledOccupancyPartners,
  });

  const { data: statuses, isLoading: isLoadingStatuses } = useQuery(
    QUERY_KEYS.RENTALS_CALCULATION_STATUS_TYPE,
    getCalculationStatusTypes,
  );

  return {
    source,
    statuses,
    isLoadingReservationFilterMobile: isLoading || isLoadingStatuses,
    isError,
  };
};
